export enum CredentialApplicationDefinitionType {
  Initial = 'Initial',
  Renewal = 'Renewal',
  Reinstatement = 'Reinstatement',
  Specialty = 'Specialty'
}
export const applicationTypesLabel = (type: CredentialApplicationDefinitionType) => {
  if (type === CredentialApplicationDefinitionType.Initial) return 'New Credential';
  return type;
};
